import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=fb70acfa&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=fb70acfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb70acfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb70acfa')) {
      api.createRecord('fb70acfa', component.options)
    } else {
      api.reload('fb70acfa', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=fb70acfa&scoped=true&", function () {
      api.rerender('fb70acfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4R6NQuLgCqTqJ/JS/comp/Voucher.vue"
export default component.exports